import { useState, useEffect } from "react";
import { S3_BASE_URL } from "../services/apiConstants";

const useDocumentUpload = (initialDocuments = []) => {
  const [documentList, setDocumentList] = useState([]);

  // Initialize document list with API-provided documents (use url only)
  useEffect(() => {
    if (initialDocuments.length > 0) {
      const transformed = initialDocuments.map((docPath, index) => {
        const fullUrl = `${S3_BASE_URL}${docPath}`;
        return {
          uid: `-${index + 1}`,
          name: docPath.split("/").pop(),
          status: "done",
          url: fullUrl,
          originFileObj: null,
        };
      });
      setDocumentList(transformed);
    }
  }, [initialDocuments]);

  // Handle new uploaded files
  const handleDocumentChange = ({ fileList: newList }) => {
    setDocumentList(newList);
  };

  // Prepare files for API submission as binary files (FormData)
  const getFilesForUpload = () => {
    if (!documentList.length) {
      return null;
    }

    // Only include newly added files (originFileObj exists)
    const filesToUpload = documentList.map((file) => file.originFileObj).filter(Boolean);
    return filesToUpload.length > 0 ? filesToUpload : null;
  };

  return {
    documentList,
    setDocumentList,
    handleDocumentChange,
    getFilesForUpload,
  };
};

export default useDocumentUpload;
